<template>
  <div v-if="data">
    <stack :column-min-width="220" :gutter-height="10" monitor-images-loaded>
      <stack-item
        v-for="(image, i) in data.results"
        :key="i"
        style="transition: transform 300ms"
      >
        <img
          class="image-wrapper"
          :src="image.urls.thumb"
          :alt="image.alt_description"
          @click="handlePhotoPage(image.id)"
        />
      </stack-item>
    </stack>
  </div>
</template>

<script>
  import { Stack, StackItem } from "vue-stack-grid";

  export default {
    name: "SearchPhotos",
    components: {
      Stack,
      StackItem,
    },
    props: ["data"],
    methods: {
      handlePhotoPage(id) {
        this.$router.push(`/photo/${id}`);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .vsg-container {
    align-self: center !important;
    height: 0 !important;
  }
  .image-wrapper {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
      0 4px 6px -2px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: all 0.2s linear;

    &:hover {
      transform: scale(1.1);
      z-index: 10;
      filter: brightness(0.7);
    }
  }
</style>
